import { MoonLoader } from 'react-spinners';

const Loading = () => {
  return (
    <main className="th-main">
      <section className="th-canvas">
        <h3 className="f2 fw4 ma0 pa0 mt10 flex justify-center">
          <MoonLoader color="#455d7a" size={60} />
        </h3>
      </section>
    </main>
  );
};

export default Loading;
